/* Collection page behavior: sort submit, mobile filter drawer, cut filter.
   Sorting and native filters use URL params so they work without JS too. */

(function () {
  function setParam(key, value) {
    var url = new URL(window.location.href);
    if (value) url.searchParams.set(key, value);
    else url.searchParams.delete(key);
    url.searchParams.delete('page');
    window.location.href = url.toString();
  }

  document.querySelectorAll('[data-wtp-sort]').forEach(function (select) {
    select.addEventListener('change', function () {
      setParam('sort_by', select.value);
    });
  });

  // Mobile filter drawer
  var toggle = document.querySelector('[data-wtp-sidebar-toggle]');
  var sidebar = document.querySelector('[data-wtp-sidebar]');
  if (toggle && sidebar) {
    toggle.addEventListener('click', function () {
      var open = sidebar.getAttribute('data-open') === 'true';
      sidebar.setAttribute('data-open', String(!open));
      toggle.setAttribute('aria-expanded', String(!open));
    });
  }

  // Native Shopify filters: submit on change so the URL stays shareable.
  var filterForm = document.querySelector('[data-wtp-filter-form]');
  if (filterForm) {
    filterForm.addEventListener('change', function (event) {
      if (event.target.matches('input[type="checkbox"][name]')) filterForm.submit();
    });
  }

  // Cut select filters the already-rendered cards client-side. Purely additive:
  // the full grid is in the DOM, so no-JS users see everything.
  document.querySelectorAll('[data-wtp-cut-filter]').forEach(function (select) {
    select.addEventListener('change', function () {
      var group = select.getAttribute('data-group');
      var grid = document.querySelector('[data-wtp-group="' + group + '"]');
      if (!grid) return;
      var want = select.value;
      grid.querySelectorAll('.wtp-card').forEach(function (card) {
        var cut = card.querySelector('.wtp-card__cut');
        var text = cut ? cut.textContent.trim() : '';
        card.hidden = Boolean(want) && text !== want;
      });
    });
  });
})();
